module.exports = __webpack_public_path__ + "static/media/google-icon.edd0e34f.svg";